import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CheckpointService, TokenStorageService } from '@app/core/services';
import { RuntimeEnvironmentService } from '@app/core/runtime-environment.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private checkpoint: CheckpointService,
    private tokenStorage: TokenStorageService,
    private runtimeEnvironmentService: RuntimeEnvironmentService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(this.addAuthCredentials(req))
      .do(event => { if (event instanceof HttpResponse) this.setAuthToken(event); })
      .catch(error => this.handleCheckpoint(error, req, next));
  }

  private isApiDomain(url: string): boolean {
    return url.startsWith(this.runtimeEnvironmentService.apiUrl);
  }

  private setAuthToken(event: HttpResponse<any>) {
    if (this.isApiDomain(event.url) && event.headers.get('Token')) {
      this.tokenStorage.setToken(event.headers.get('Token'));
    }
  }

  private addAuthCredentials<T>(req: HttpRequest<T>): HttpRequest<T> {
    const token = this.tokenStorage.getToken();
    if (this.isApiDomain(req.url) && token) {
      req = req.clone({
        headers: req.headers.set('Authorization', 'Token ' + token)
      });
    }
    return req;
  }

  private handleCheckpoint(error: any, failedRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isApiDomain(failedRequest.url) || error.status !== 401) {
      throw error;
    }

    this.tokenStorage.setToken(null);

    return Observable.create(observer => this.checkpoint.observer.next(observer))
      .switchMap(resolved => {
        if (!resolved) {
          return Observable.throw({ error: {message: 'Требуется авторизация'}, status: 401 });
        }

        // repeat
        return next.handle(this.addAuthCredentials(failedRequest));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/http-interceptors/auth-interceptor.service.ts